import { apiUrl } from '@algoan/dashboard/env';
import { FoldersCsvConfig } from './application-model';
import { formatDateForFile, getMongoSortValue } from '@algoan/dashboard/utils';
import { AxiosRequestConfig } from 'axios';

export const getFileName = (): string => `export-${formatDateForFile(new Date())}.csv`;

export const getCustomersCsvUrl = (params: {
  startDate?: Date | null;
  endDate?: Date | null;
  projectId?: string;
}): string => {
  const startDate = params.startDate;
  const endDate = params.endDate;
  const projectId = params.projectId;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const optionalFilter = startDate || endDate ? { 'dashboard.createdAt': { $gte: startDate, $lte: endDate } } : {};
  const filter = encodeURIComponent(
    JSON.stringify({
      customIdentifier: { $exists: true, $not: { $type: 'null' } },
      projectId,
      dashboard: { $exists: 1 },
      ...optionalFilter,
    }),
  );
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const sort = encodeURIComponent(JSON.stringify({ 'dashboard.createdAt': getMongoSortValue('DESC') }));

  return `${apiUrl}/v2/customers/csv?filter=${filter}&sort=${sort}`;
};

export const getCsvRequestArguments = (
  csvConfig: FoldersCsvConfig,
): {
  method: 'POST' | 'GET';
  config: AxiosRequestConfig;
} => ({
  method: 'GET',
  config: {
    params: {
      extraProperties: csvConfig.columns.map((column) => column.path).join(),
      renameProperties: csvConfig.columns.map((column) => column.name).join(),
    },
  },
});
